export enum CompanyType {
  COMPANY = 1,
  FARM = 2,
}
export enum EntityType {
  PACKHOUSE = 1,
  FARM = 2,
}
